import { Component, ViewChild, ChangeDetectorRef, HostListener } from '@angular/core';
import { MatSidenav } from '@angular/material';
import { SideNavServiceService } from './services/side-nav-service.service';
import { LoginService } from './services/login.service';
import { NavigationService } from './services/navigation.service';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { SharedService } from "./shared.service";
import { LearnerService } from './services/learner.service';
import { JobService } from './services/jobs/job.service';
import { CompetenciesService } from './services/competencies.service';
import { Subscription } from 'rxjs';
import { NotificationService } from './services/notification.service';
import { SwUpdate } from '@angular/service-worker';
import { AssetService } from './services/asset.service'
import { AccidentService } from './services/accident.service';
import { FileService } from './services/file.service';
import { Subject } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';
import { BreakpointObserver } from '@angular/cdk/layout';
import { UtilityService } from './services/utility.service';
import { EncryptDecryptService } from './services/encrypt-decrypt.service';

declare var $: any;
export let browserRefresh = false;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  @ViewChild('sidenav', { static: false }) public mydsidenav: MatSidenav;
  @ViewChild('mySidemenu', { static: false }) public sidemenu: MatSidenav;
  sidenav: MatSidenav;
  isPrint: boolean;
  loading: boolean = false;
  details: any;
  isComp: boolean = false;
  fileTitle: any;
  fileId: any;
  type: any;
  currentOutlet: any;
  comp: any;
  displayCloseBtn: boolean;
  compIndex: any;
  user: any;
  isAssessment: boolean;
  assessment: any;
  isAccidentHidden: boolean
  module: any;
  isMenuOpened: boolean = false
  @HostListener('window:beforeprint', ['$event'])
  onBeforePrint(event) {
    this.isPrint = true
    $(".main").addClass('mainPrint')
    $(".sidebar").addClass('sidebarPrint')
  }

  @HostListener('window:afterprint', ['$event'])
  onAfterPrint(event) {
    this.isPrint = false
    $(".main").removeClass('mainPrint')
    $(".sidebar").removeClass('sidebarPrint')
    // $(".sidebar").css('display', 'block');

  }
  reason = '';
  matrialObject
  loggedInUser;
  currentUser;
  learnerRouteName;
  instructorRouteName;
  clientRouteName;
  toolTip: any = 'expand';
  isVisible: boolean = false;
  disableTooltip;
  userRole
  disabled: boolean;
  public onlineOffline: boolean = navigator.onLine;
  learnerJob = []
  selectedJob
  subscription: Subscription;
  msg
  displayCount
  isProfile: boolean = false
  isClientUser: boolean = false
  // opened: boolean;


  private fileDetailsSubscription: Subject<any> = new Subject<any>();
  private jobFromJobsComponent: Subject<any> = new Subject<any>();
  private notificationCountSubscription: Subject<any> = new Subject<any>();
  constructor(
    public routingState: NavigationService,
    public cd: ChangeDetectorRef,
    private router: Router,
    public route: ActivatedRoute,
    private sidenavService: SideNavServiceService,
    private _loginService: LoginService,
    private _sharedService: SharedService,
    public _learnerService: LearnerService,
    public jobService: JobService,
    private notificationService: NotificationService,
    private swUpdate: SwUpdate,
    public _assetService: AssetService,
    public _accidentService: AccidentService,
    public _fileService: FileService,
    public _competencyService: CompetenciesService,
    public _utilityService: UtilityService,
    public _encryptDecryptService: EncryptDecryptService
  ) {
    let myModule = {
      isTrainingJob: true
    }


    this.route.queryParams.subscribe((params) => {
      console.log("THIS IS THE PARAMS DATA", params)
      if (params && params.isDigital || params._isSponsor) this.isVisible = true
    })

    this._loginService.getLoggedInUser().subscribe((userLogin) => {
      console.log("This is the user login data", userLogin);
      // this.currentUser = userLogin.currentUser
      let currentUser = userLogin.currentUser
      if (currentUser && currentUser.userRole.length && currentUser.userRole.includes('client')) this.checkClientUser(currentUser)
    })

    this._competencyService.competencyFile.subscribe((data) => {
      this.details = data.competency
      this.isComp = true;
      this.mydsidenav.open()
    })

    this._assetService.fileDetailsObservable().subscribe((res) => {
      console.log("when file is click", res);
      if (res && res.file) {
        this.details = res.file;
        this.fileTitle = this.details.alias ? this.details.alias : this.details.title
        this.fileId = this.details._id
        this.type = res.file.type
        this.isComp = false
        this.displayCloseBtn = true
      }
      else if (res.event.type === 'folder') {
        this.details = res.event
        this.fileTitle = this.details.alias ? this.details.alias : this.details.title
        this.fileId = this.details._id
        this.type = res.event.type
        this.displayCloseBtn = false
      } else if (res.event && res.event && res.event.type == 'file') {
        this.details = res.event
        this.fileTitle = this.details.alias ? this.details.alias : this.details.title
        this.fileId = this.details._id
        this.type = res.event.type
        this.displayCloseBtn = false
      }
      else {
        this.details = res.event.file;
        this.fileTitle = this.details.alias ? this.details.alias : this.details.title
        this.fileId = this.details._id
        this.type = res.event.file.type
        this.displayCloseBtn = true
      }
      // this.displayCloseBtn = true
      this.mydsidenav.open()
    })

    this.isAccidentHidden = false

    this._accidentService.displayAccidentTabObservable().subscribe((res) => {
      console.log("when file is here check data accident==========>", res);

      this.isAccidentHidden = res.isAccident;
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'))
      console.log("here is the curreent user..", this.currentUser)
      // this.user = JSON.parse(localStorage.getItem('userRoles'))



    })


    this._assetService.closeFileDetailsObservable().subscribe((res) => {
      console.log("res------>", res);

      if (res)
        this.closeSidnav()
    })

    // localStorage.setItem('module',JSON.stringify(myModule))
    // this._loginService.modulesSet.emit('done')
    console.log("Child SideBar", this.sidemenu)
    if (!this.isVisible) {
      this.notificationService.getNotificationCount().
        pipe(
          takeUntil(this.notificationCountSubscription)
        )
        .subscribe((data) => {
          console.log("when new notification get", data, this.isVisible);
          this.displayCount = data.count;
        })
    }


    // this.msg = this.notificationService.notificationCount
    // console.log("when new  notification created", this.msg);
    this.subscription = router.events.subscribe((event) => {
      // console.log("what is the event to be refresh", event);

      if (event instanceof NavigationStart) {
        browserRefresh = !router.navigated;
      }
    });



    this.jobService.getJobFromJobsComponent()
      .pipe(
        takeUntil(this.jobFromJobsComponent)
      )
      .subscribe((res: any) => {
        let jobArray = JSON.stringify(res.jobs)
        if (jobArray && jobArray.length > 0) {
          console.log("when get  jobs for leaner", res.jobs, this.user);
          if (this.user && this.user.isLearner) {

            this.learnerJob = res.jobs.jobs
            // this.selectedIndex = 0
            this.selectedJob = res.jobs.selectedJob
          } else {
            this.learnerJob = []
          }
        }
      })

    this._loginService.userRole.subscribe(res => {
      this.loggedInUser = res;
      console.log('this.loggedInUser', res);
      this.cd.detectChanges()
    })
    routingState.loadRouting();
    this._loginService.userRolesSet.subscribe(res => {
      this.user = JSON.parse(localStorage.getItem('userRoles'))
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'))
      this.cd.detectChanges()
      this._loginService.userProfile.subscribe(res => {
        this.currentUser = res;
        this.cd.detectChanges()
        if (res && res != null) {
          this.currentUser = res;
          if (this.user.isLearner) {

            this.learnerRouteName = '/user/' + this.currentUser._id;
            console.log(' this.currentUser in app component  @133 ', this.learnerRouteName);
          }
        }


        if (this.user.isTrainer || this.user.isMp || this.user.isStaff) {
          this.instructorRouteName = '/staff/' + this.currentUser._id;
          console.log(' this.currentUser', this.instructorRouteName);
        }

        if (this.user.isClient) {
          this.clientRouteName = '/client/' + this.currentUser._id;
          console.log(' this.currentUser', this.clientRouteName);
        }
      })
      this.checkUserRole()
    })

    this._loginService.modulesSet.subscribe(moduleRes => {
      this.module = JSON.parse(localStorage.getItem('module'))
      console.log("single module data", this.module);

      this.cd.detectChanges()
    })



    // SIDE PANEL OPEN FOR MY DOCUMENT PAGE

    this._fileService.sideMenuObservable().subscribe((res) => {
      console.log("WHAT IS THE VALUE OF SIDE PANEL FOR QUIZ", res);
      this.filPreviewForSidePanel(res)
    })




  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.fileDetailsSubscription.next()
    this.fileDetailsSubscription.complete()
    this.jobFromJobsComponent.next()
    this.jobFromJobsComponent.complete()
    this.notificationCountSubscription.next()
    this.notificationCountSubscription.complete()

  }

  openSideMenu() {
    this.isMenuOpened = !this.isMenuOpened
  }

  onToggle() {
    // this.opened = !this.opened
    // $(".sidebar").toggleClass('sidebar--Collapse');
    // $('.main').toggleClass('menu--open');
    // $('body').toggleClass('overflow_hidden');
    // $('#toggleIcon').toggleClass('rotate');
    // $(".sidebar").hasClass('sidebar--Collapse') ? $(".tooltip-class").css({ 'display': 'block' }) : $(".tooltip-class").css({ 'display': 'none' });
    // $('.sidebar ul li a').click(function () {
    //   let windowWidth = $(window).width();
    //   if (windowWidth < 1025) {
    //     $(".sidebar").addClass('sidebar--Collapse');
    //     $('.main').removeClass('menu--open');
    //     $('body').removeClass('overflow_hidden');
    //     $('#toggleIcon').addClass('rotate');
    //   }
    // });
    // if (!this.opened)
  }

  ngOnInit(): void {

    // this.sidemenu.opened

    console.log("true.............", this.router.url);
    // if(this.router.url == '/mydocuments/single-folder'){

    //   this.displayCloseBtn = false;
    // }
    let userData = JSON.parse(localStorage.getItem('currentUser'))
    // this.currentUser= userData
    console.log("what is current user data", userData);
    if (userData != undefined || userData != null) {
      this.getTotalCountOfUser()
    }
    this.module = JSON.parse(localStorage.getItem('module'))
    console.log("module details", this.module);
    const userRole = JSON.parse(localStorage.getItem('userRoles'))
    if (userRole && userRole.isLearner) {
      // this.checkAccidentValidation(userData)
      console.log("current user while refresh", userRole);
      let learnerId = userData._id
      let jobId = userData.jobs[0]._id
      this._learnerService.getLearner(learnerId, jobId).subscribe((data) => {
        console.log("data while page is refresh", data);
        this.learnerJob = data[0].job
        this.selectedJob = data[0].job[0]._id
      }, error => {
        console.log("error while get details", error);

      })
    }
    // this.getTotalCountOfUser()  
    // console.log("current user data here!!!!!!!!!!!==>",this.currentUser.userId)



    this.notificationService.receiveMessage()

    $('.collapseToggle').on('click', function (e) {
      console.log("What is eeee", e);

      $(".sidebar").toggleClass('sidebar--Collapse');
      $('.main').toggleClass('menu--open');
      $('body').toggleClass('overflow_hidden');
      $('#toggleIcon').toggleClass('rotate');
      $(".sidebar").hasClass('sidebar--Collapse') ? $(".tooltip-class").css({ 'display': 'block' }) : $(".tooltip-class").css({ 'display': 'none' });
      $('.sidebar ul li a').click(function () {
        let windowWidth = $(window).width();
        if (windowWidth < 1025) {
          $(".sidebar").addClass('sidebar--Collapse');
          $('.main').removeClass('menu--open');
          $('body').removeClass('overflow_hidden');
          $('#toggleIcon').addClass('rotate');
        }
      });
    });

    this.sidenavService.setSidenav(this.sidemenu);

    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.cd.detectChanges()
    this.loggedInUser = localStorage.getItem("token");
    this.user = JSON.parse(localStorage.getItem('userRoles'))

    console.log(' this.currentUser in app page', this.currentUser);

    if (this.user && this.user.isLearner) {
      console.log();
      this.learnerRouteName = '/user/' + this.currentUser._id;
      console.log(' this.currentUser in app component  @133 ', this.learnerRouteName);
    }
    if (this.user && (this.user.isTrainer || this.user.isMp || this.user.isStaff || this.user.isOperative)) {
      this.instructorRouteName = '/staff/' + this.currentUser.userId;
    }
    if (this.currentUser && this.currentUser.userRole.length && this.currentUser.userRole.includes('client')) this.checkClientUser(this.currentUser)
    this.checkUserRole()


    if (this.swUpdate.isEnabled) {

      this.swUpdate.available.subscribe((data) => {
        console.log("UPDATE NEW VERSION", data)
        if (confirm("New version available. Load New Version?")) {
          window.location.reload();
        }
      });
    }
    console.log("USER ROLE OF LOGIN USER", this.user)
    this.checkSessionStorage()

    this.checkSessionStorage()
  }

  checkSessionStorage() {
    const sessionStorageData = JSON.parse(sessionStorage.getItem('auth'))
    if (sessionStorageData) {
      console.log("SESSION storage data: ", sessionStorageData.primary, sessionStorageData.secondary)
    } else {
      this._utilityService.updatePlatformData().subscribe((data) => {
        console.log("SESSION storage data", data)
        const credentials = this._encryptDecryptService.platFormDecrypt(data)
        console.log("SESSION storage credentials: ", credentials)
        sessionStorage.setItem('auth', credentials);
      })
    }
  }

  
  onRedirection() {
    var className = $('#maincontainer').attr('class');
    if (className.includes('menu--open')) {
      $(".sidebar").addClass('sidebar--Collapse');
      $('.main').removeClass('menu--open');
      $('body').removeClass('overflow_hidden');
      $('#toggleIcon').addClass('rotate');
    }
  }


  checkUserRole() {
    console.log("what is the user role data", this.user);

    if (this.user && !this.user.isLearner && (this.user.isTrainer || this.user.isMp || this.user.isIQA || this.user.isIncidentUser || this.user.isOperative || this.user.isAssetManager)) {

      this.isProfile = true
      console.log("first one", this.isProfile);
    }

    if (this.user && (this.user.isLearner && this.user.isOperative)) {
      this.isProfile = true
      console.log("Second one", this.isProfile);
    }

    if (this.user && this.user.isLearner && !this.user.isOperative) {
      this.isProfile = false
      console.log("third  one", this.isProfile);
    }
    if (this.user && (this.user.isLearner || this.user.isClient)) {
      this.isProfile = false
      console.log("Fourth one", this.isProfile);
    }
    // if (this.user && this.user.isLearner) this.isProfile = false

  }


  checkClientUser(currentUser) {
    if (currentUser && currentUser.isClient) {
      this.isClientUser = true
    } else {
      if ((!currentUser.isClient && currentUser.isAllow)) this.isClientUser = true
      else this.isClientUser = false
    }
  }

  userDashboard() {
    // $("#profile").addClass("active-link");

    if (this.user && (this.user.isTrainer || this.user.isMp || this.user.isIncidentUser || this.user.isOperative) && !this.user.isLearner) {
      console.log("notfor learner");

      this.router.navigate(['/staff/view/' + this.currentUser._id])
    }
    if (this.user && (this.user.isLearner && this.user.isOperative)) {
      console.log("this is for learner ", this.currentUser);
      this.router.navigate(['/user/view/' + this.currentUser._id], { queryParams: { job: this.currentUser.jobs[0]._id } });

    }
  }



  instructorJobs() {
    let display = false
    this._learnerService.instructorJobs(display)
  }

  getToolTipEvent() {
    return $(".sidebar").hasClass('sidebar--Collapse');
  }

  getToolTip() {
    if ($(".sidebar").hasClass('sidebar--Collapse')) {
      this.disabled = true;
    }
    else {
      this.disabled = false;
    }
    return $(".sidebar").hasClass('sidebar--Collapse') ? 'expand' : 'collapse';
  }

  close(reason: string) {
    this.sidemenu.close();
  }

  Logout(userId) {
    $(".main").css({ 'padding': '100px 20px 20px' });
    console.log('Logout is called');
    this.loading = true
    this._loginService.logout(userId);
    this.loading = false
  }

  eventFromTitleBar(event) {
    console.log("event on itm clicked", event)
    console.log("this.user", this.user)
    if (event.value == 'logout') {
      this.Logout(event.userId)
    } else {
      if (this.user.isAdmin) {
        this.router.navigate(['/resetpassword/admin'])
      } else {
        this.router.navigate(['/resetpassword/user'])
      }
    }
  }


  redirectToAsset() {
    console.log("current user role", this.user);
    if (this.user && (this.user.isAdmin || this.user.isAssetManager || this.user.isManager)) {
      this.router.navigate(['/asset'])
    } else {
      this.router.navigate(['/asset/asset-list'])
    }


  }


  redirectNotification() {
    this.selectedJob = null
    this.router.navigate(['/notification'])
  }

  openFileDetails(event) {
    // that event will be caught here
    console.log("IN app component", event);
    // if (event.file != undefined) {
    //   this.details = event.file;
    //   this.fileTitle = this.details.alias ? this.details.alias : this.details.title
    //   this.fileId = this.details._id
    //   this.type = event.file.type
    // }
    // else {
    //   this.details = event
    //   this.fileTitle = this.details.alias ? this.details.alias : this.details.title
    //   this.fileId = this.details._id
    //   this.type = event.type
    // }
    this.mydsidenav.open()
  }




  // FUNCTION FOR OPEN SIDE PANEL USING SERVICE



  filPreviewForSidePanel(res) {
    if (res && res.assessment) {

      this.assessment = res.assessment
      this.isAssessment = true
      // if (event.type === "appear-quiz") {
      this.displayCloseBtn = false;
      $('#closeButton').addClass('showCloseBtn')
      this.mydsidenav.open()
      // } else {
      //   this.displayCloseBtn = true;
      //   $('#closeButton').removeClass('showCloseBtn')
      // }
      this.cd.detectChanges()
      console.log("CALL THIS PART TO BE DISPLAY", this.assessment, this.isAssessment);
    }
    else {
      if (res.event && res.event.event && res.event.event.index) {
        console.log("res.event.index ===>>>", res.event.event.index)
        this.compIndex = res.event.event.index
      }
      console.log("openFilesSideNav", res);
      // console.log("res.event.event.file ", res.event.event.event.file);
      this.matrialObject = res
      if (res.event.file != undefined) {
        this.details = res.event.file;
        this.fileTitle = this.details.alias ? this.details.alias : this.details.title
        this.fileId = this.details._id
        this.type = res.event.file.type
        this.displayCloseBtn = true
      }
      else if (res.event.event && res.event.event.file) {
        console.log("else if ")
        this.displayCloseBtn = true
        this.details = res.event.event.file
        this.fileTitle = this.details.alias ? this.details.alias : this.details.title
        this.fileId = this.details._id
        this.type = res.event.event.file.type
      }
      else if (res.event.event && res.event.event.event.file) {
        console.log("Perfect ------------------> ")
        this.details = res.event.event.event.file
        this.fileTitle = this.details.alias ? this.details.alias : this.details.title
        this.fileId = this.details._id
        this.type = res.event.event.event.file.type
      }
      else {
        console.log("   ------------------> ", event)

        this.details = res.event
        this.fileTitle = this.details.alias ? this.details.alias : this.details.title
        this.fileId = this.details._id
        this.type = res.event.type
      }
      this.mydsidenav.open()
      this.isComp = false;
      console.log("FILE DETAILS TO BE SEND", this.details);

    }
  }







  public onActivate(event: any) {
    if (localStorage.getItem('loginModel')) localStorage.removeItem('loginModel')
    if (event.isMyDocs) {
      this.displayCloseBtn = false;
      $('#closeButton').addClass('showCloseBtn')
    } else {
      this.displayCloseBtn = true;
      $('#closeButton').removeClass('showCloseBtn')
    }
    console.log("ACTIVE COMPONENT", event, this.displayCloseBtn);
    this.currentOutlet = event;
    if (event.type === "appear-quiz") {
      this.displayCloseBtn = false;
      $('#closeButton').addClass('showCloseBtn')
    } else {
      this.displayCloseBtn = true;
      $('#closeButton').removeClass('showCloseBtn')
    }
    //  console.log("ACTIVE COMPONENT IS", event.activatedRoute.component.name);
    // if (event && event.activatedRoute && (event.activatedRoute.component.name == 'SingleUnitComponent' || event.activatedRoute.component.name == 'SingleInstructorComponent')) {
    //   $('#closeButton').removeClass('close_btn')
    //   $('#closeButton').addClass('close_btn_material')
    // }
    // else {
    //   $('#closeButton').addClass('close_btn')
    //   $('#closeButton').removeClass('close_btn_material')
    // }

    if (event && event.isAssessment && event.isAssessment == true) {
      console.log("");
      this.isAssessment = true
      this.mydsidenav.open()
    }
    else {
      this.isAssessment = false
    }

    if (event && event.closeBtnNeeded && event.closeBtnNeeded == true) {
      console.log("closeBtnNeeded", event.closeBtnNeeded)
      this.displayCloseBtn = true;
      // $('#closeButton').removeClass('close_btn')
      // $('#closeButton').addClass('close_btn_material')
    }
    else {
      console.log("closeBtnNeeded NOT", event.closeBtnNeeded)
      this.displayCloseBtn = false;
      // $('#closeButton').addClass('close_btn')
      // $('#closeButton').removeClass('close_btn_material')
    }
    if (this.currentOutlet.keepSideNavOpen && this.currentOutlet.keepSideNavOpen == true) {
      $('#closeButton').addClass('showCloseBtn')
      // if (this.isLargeScreen()){
      this.displayCloseBtn = false;
      // }
      // else{
      //   this.displayCloseBtn = true;
      // }
      console.log("side nav open");
    }
    else {
      $('#closeButton').removeClass('showCloseBtn')
      this.mydsidenav.close()
    }
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);




    if (event.openFilesSideNav) {
      event.openFilesSideNav.subscribe(res => {
        console.log("openFilesSideNav called==>", res);

        if (res && res.assessment) {
          this.assessment = res.assessment
          this.mydsidenav.open()
        }
        else {
          if (res.event && res.event.event && res.event.event.index) {
            console.log("res.event.index ===>>>", res.event.event.index)
            this.compIndex = res.event.event.index
          }
          console.log("openFilesSideNav", res);
          // console.log("res.event.event.file ", res.event.event.event.file);
          this.matrialObject = res
          if (res.event.file != undefined) {
            this.details = res.event.file;
            this.fileTitle = this.details.alias ? this.details.alias : this.details.title
            this.fileId = this.details._id
            this.type = res.event.file.type
            this.displayCloseBtn = true
          }
          else if (res.event.event && res.event.event.file) {
            console.log("else if ")
            this.displayCloseBtn = true
            this.details = res.event.event.file
            this.fileTitle = this.details.alias ? this.details.alias : this.details.title
            this.fileId = this.details._id
            this.type = res.event.event.file.type
          }
          else if (res.event.event && res.event.event.event.file) {
            console.log("Perfect ------------------> ")
            this.details = res.event.event.event.file
            this.fileTitle = this.details.alias ? this.details.alias : this.details.title
            this.fileId = this.details._id
            this.type = res.event.event.event.file.type
          }
          else {
            console.log("LAST ELSE CALL FOR FOLDER ", res.event)

            this.details = res.event
            this.fileTitle = this.details.alias ? this.details.alias : this.details.title
            this.fileId = this.details._id
            this.type = res.event.type
          }
          this.mydsidenav.open()
          this.isComp = false;
        }
      })
    }
    else if (event.activatedRoute && event.activatedRoute.component.name == 'SingleInstructorComponent' && event.getFileDetails) {
      event.getFileDetails.subscribe(res => {
        console.log("getFileDetails in app compnent", res);
        if (res.compIndex) {
          console.log("res.event.compIndex", res.compIndex);
          this.compIndex = res.compIndex
        }
        this.details = res.competency
        this.isComp = true;
        this.mydsidenav.open()
      })
    }
    else if (event.openCompPanel) {
      event.openCompPanel.subscribe(res => {
        console.log("openCompPanel in app compnent", res);
        this.details = res.competency
        this.isComp = true;
        this.mydsidenav.open()
      })
    }

    if (event.closeFilesSideNav) {
      console.log("what is event", event.closeFilesSideNav);

      console.log("this.compIndex on closeFilesSideNav", this.compIndex)
      if (this.compIndex) {
        console.log("this.compIndex", this.compIndex)
        $('#' + this.compIndex).removeClass('active');
      }
      console.log("closing")
      event.closeFilesSideNav.subscribe(res => {
        console.log("response of something---------^^^^^^^", res);

        console.log("closing")
        this.closeSidnav()
      })
    }
    // });
  }


  public onSponsorActivate(event: any) {
    console.log("Sponsor activated", event);
    if (event.isTopToApp)
      event.isTopToApp.subscribe(res => {
        $('.form-scroll').scrollTop(0)
      })
  }

  closeSidnav() {
    console.log("closing")
    console.log("this.compIndex on close", this.compIndex)
    if (this.compIndex) {
      console.log("this.compIndex", this.compIndex)
      $('#' + this.compIndex).removeClass('active');
      $('#' + this.compIndex).removeClass('cardBorder');
    }
    this.mydsidenav.close()
    console.log("closing")
    // this.removeCssClass = true;
    $('.parent_row').removeClass('col-width-class');
    $('#downloadBtn').removeClass('col-md-12')
    $('#btns').removeClass('col-md-12')
  }
  compAdded(event) {
    console.log("***EVENT IS", event);
    console.log("***outlet is", this.currentOutlet);
    // if (this.currentOutlet.activatedRoute.component.name == 'SingleInstructorComponent'){
    console.log("In if");
    this.comp = event
    this._sharedService.nextCompetency(event)
    if (event.competency) {
      console.log("IN NEW IF")
      this.closeSidnav()
    }
    // this.currentOutlet.newAddedCompetency = event;
    // }
  }
  deleteCompetency(event) {
    if (event.competency) {
      console.log("IN NEW IF")
      this.closeSidnav()
    }
  }

  fileDeleted(event) {
    console.log("delete event app component", event)
    // if (event.type == "folder"){
    console.log("in if");
    this._sharedService.folderDeleted(event)
    if (event.fileId && event.type == 'material') {
      this.mydsidenav.close()
    }

    // }
  }
  deletedFile(event) {
    console.log("event---------->", event);
    this._sharedService.fileDeleted(event)
    if (event.fileId && event.type == 'material') {
      this.mydsidenav.close()
    }
  }


  fileMarkasRead(event) {

    this._sharedService.markasReadFile(event)


  }

  deleteFile(event) {
    this._sharedService.fileDelete(event)
    if (event) this.mydsidenav.close()
  }
  isLargeScreen() {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (width > 720) {
      // this.displayCloseBtn = false;
      return true;
    } else {
      // this.displayCloseBtn = true;
      return false;
    }
  }

  fileDetailsOpened(event) {
    // alert("File details opened")
    $('#thumbNailImg').removeClass('imgSizeIcon')
    $('#thumbNailImg').addClass('imgReSizeIcon')
  }

  fileDetailsClosed(event) {
    $('#thumbNailImg').addClass('imgSizeIcon')
    $('#thumbNailImg').removeClass('imgReSizeIcon')
    // alert("File details Closed")
  }
  folderTitleChenged(event) {
    console.log(event)
  }


  singleJob(job) {
    console.log("single job details============", job);
    // this._learnerService.singleJob(job._id)
    let learnerId = this.currentUser._id
    let jobId = job._id
    this.router.navigate(['/learner/view/' + learnerId], { queryParams: { job: jobId } });
  }


  clientUserList() {
    this.router.navigate(['/client/list'], { queryParams: { users: this.currentUser._id } });
  }

  // @HostListener('window:scroll', ['$event'])
  // onScroll(e) {
  //   console.log('window', e);
  //   if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
  //     // document.getElementById("topnav").classList.add("transitionEffect");
  //     $("#topnav").addClass("transitionEffect")
  //     // document.getElementById("sideBar").style.paddingTop = "54px";
  //     // document.getElementById("sideBar").classList.add("mystyle");
  //     // document.getElementById("topnav").style.height = "54px";
  //   } else {
  //     $("#topnav").removeClass("transitionEffectl")
  //     // document.getElementById("sideBar").classList.remove("mystyle");
  //     // document.getElementById("topnav").style.height = "64px";
  //     // document.getElementById("sideBar").style.paddingTop = "64px";
  //   }
  // }
  // prepareRoute(outlet: RouterOutlet) {
  //   return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  // }





  getTotalCountOfUser() {
    this.notificationService.totalCounts().subscribe((response) => {
      console.log("response of total count", response);
      this.displayCount = response
    }, error => {
      console.log("error while get total count", error);

    })
  }
}
